<template>
  <el-menu mode="vertical" class="sidebar-el-menu" :default-active="onRoutes" :collapse="false" background-color="#324157"
           text-color="#bfcbd9" active-text-color="#409EFF" unique-opened router>
    <template v-for="item in items">
      <template v-if="item.subs">
        <el-submenu :index="item.url" :key="item.url">
          <template slot="title">
            <i class="ldms-font" :class="item.icon"></i><span slot="title">{{ item.menuName }}</span>
          </template>
          <el-menu-item v-for="(subItem,i) in item.subs" :key="i" :index="subItem.url">
            {{ subItem.menuName }}
          </el-menu-item>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item :index="item.url" :key="item.url">
          <i class="ldms-font" :class="item.icon"></i><span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </template>
  </el-menu>
</template>
<script>

export default {
  props: {
    items: Array
  },
  data () {
    return {
      collapse: false
    }
  },
  created () {
    // let _this = this
    // getAppMenu(this.$route.params.id).then(res => {
    //   _this.items = res.data.data
    //   console.log(res.data)
    // })
    // this.getItems(this.$route.params.id)
  },
  watch: {
  },
  computed: {
    onRoutes () {
      return this.$route.path
    }
  },
  methods: {
    getItems (appId) {
      return [
        {
          icon: 'ldms-ai-home',
          index: '/app/' + appId + '/appDashboard',
          title: '首页面板'
        },
        {
          icon: 'ldms-heibanblackboard10',
          index: '/app/' + appId + '/blackBoard',
          title: '货源小黑板'
        },
        {
          icon: 'ldms-document',
          index: '/app/' + appId + '/receiptList',
          title: '配货单列表'
        },
        {
          icon: 'ldms-tongji',
          title: '数据统计',
          index: '4',
          subs: [
            // {
            //   index: '/app/' + appId + '/statistics/finance',
            //   title: '财务统计'
            // },
            {
              index: '/app/' + appId + '/statistics/financeUser',
              title: '个人统计'
            },
            {
              index: '/app/' + appId + '/statistics/driverHistory',
              title: '拉货历史'
            },
            {
              index: '/app/' + appId + '/statistics/driverOrderBySale',
              title: '车辆排名'
            },
            {
              index: '/app/' + appId + '/statistics/financeByYear',
              title: '年度统计'
            }
          ]
        },
        {
          icon: 'ldms-guanli',
          index: '3',
          title: '应用管理',
          subs: [
            {
              index: '/app/' + appId + '/person',
              title: '人员管理'
            },
            {
              index: '/app/' + appId + '/supply',
              title: '经理管理'
            },
            {
              index: '/app/' + appId + '/driver',
              title: '司机信息'
            },
            {
              index: '/app/' + appId + '/car',
              title: '车辆信息'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.sidebar-el-menu .ldms-font{
  position: relative;
  font-size: 18px;
  top: -2px;
  right: 4px;
}
</style>
